exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js!../assets/css/layer/layer.css"), "");
exports.i(require("-!../../node_modules/css-loader/index.js!../assets/css/common.css"), "");

// module
exports.push([module.id, "/*@import '../styles/variables';*/\nhtml, body{\n  height: 100%;\n  font-family: Arial, Helvetica, sans-serif\n}\n\na.active {\n    background-color: gray;\n    text-decoration: none;\n}\n.sstj .ant-input{\n    padding-left: 10px !important;\n}\n.ant-table-tbody > tr > td .ant-btn{\n  height: 22px;\n}\n/* .ant-dropdown .ant-dropdown-menu{\n      background: #ff9600;\n}\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item{\n    background: #ff9600;\n    color: #fff;\n}\n.ant-dropdown-menu .ant-dropdown-menu-item a{\n    color: #fff;\n}\n.ant-dropdown-menu .ant-dropdown-menu-item a .anticon{\n    margin-right: 8px;\n} */\n.ant-pagination-jump-prev:after, .ant-pagination-jump-next:after{\n    display: inline-block !important;\n}\n*::-webkit-scrollbar{\n    width: 5px;\n}\n*::-webkit-scrollbar-thumb {\n    background-color: #aeafa7;\n    border-radius: 10px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/app.component.css
// module id = 1042
// module chunks = 75